import { Link } from '@tanstack/react-router';

/** Finanzas has two faces: the running P&L with gastos, and the reports built from it. */
export function FinanzasTabs() {
  return (
    <nav className="seg finanzas-tabs" aria-label="Secciones de Finanzas">
      <Link to="/finanzas" activeOptions={{ exact: true }} activeProps={{ 'aria-current': 'page' }}>
        Resumen
      </Link>
      <Link to="/finanzas/reportes" activeProps={{ 'aria-current': 'page' }}>
        Reportes
      </Link>
    </nav>
  );
}
